var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#15225D;}\n\t.st1{clip-path:url(#SVGID_00000116928970643468498420000014158604166277286311_);fill:#212D65;}\n\t.st2{fill:#212D65;}\n\t.st3{clip-path:url(#SVGID_00000013182600841795027140000011539029990072337854_);fill:#212D65;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.8,241.4h92.4c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1h-92.4c-1.7,0-3.1,1.4-3.1,3.1 C250.7,240,252.1,241.4,253.8,241.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.8,266.1h55.4c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1h-55.4c-1.7,0-3.1,1.4-3.1,3.1 C250.7,264.7,252.1,266.1,253.8,266.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.1,229.1h-37c-1.7,0-3.1,1.4-3.1,3.1v37c0,1.7,1.4,3.1,3.1,3.1h37c1.7,0,3.1-1.4,3.1-3.1v-37 C229.2,230.4,227.8,229.1,226.1,229.1 M223,266.1h-30.8v-30.8H223V266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.8,318.5h92.4c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1h-92.4c-1.7,0-3.1,1.4-3.1,3.1 C250.7,317.1,252.1,318.5,253.8,318.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.8,343.2h55.4c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1h-55.4c-1.7,0-3.1,1.4-3.1,3.1 C250.7,341.8,252.1,343.2,253.8,343.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.1,306.2h-37c-1.7,0-3.1,1.4-3.1,3.1v37c0,1.7,1.4,3.1,3.1,3.1h37c1.7,0,3.1-1.4,3.1-3.1v-37 C229.2,307.6,227.8,306.2,226.1,306.2 M223,343.2h-30.8v-30.8H223V343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.9,389.4h-80.1c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h80.1c1.7,0,3.1-1.4,3.1-3.1 C337,390.8,335.6,389.4,333.9,389.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.2,414.1h-55.4c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h55.4c1.7,0,3.1-1.4,3.1-3.1 S310.9,414.1,309.2,414.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.1,383.3h-37c-1.7,0-3.1,1.4-3.1,3.1v37c0,1.7,1.4,3.1,3.1,3.1h37c1.7,0,3.1-1.4,3.1-3.1v-37 C229.2,384.7,227.8,383.3,226.1,383.3 M223,420.3h-30.8v-30.8H223V420.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.1,380.2c0-31.3-24.6-56.8-55.4-58.4V164.3c0-1.7-1.4-3.1-3.1-3.1h-70.8v-15.4c0-1.7-1.4-3.1-3.1-3.1 h-21.6v-4.3c0-18-15.2-32.7-33.9-32.7s-33.9,14.7-33.9,32.7v4.3h-21.6c-1.7,0-3.1,1.4-3.1,3.1v15.4H143c-1.7,0-3.1,1.4-3.1,3.1 v326.9c0,1.7,1.4,3.1,3.1,3.1h258.7c1.7,0,3.1-1.4,3.1-3.1v-52.6C435.5,437,460.1,411.5,460.1,380.2 M244.6,138.4 c0-14.7,12.4-26.6,27.7-26.6c15.3,0,27.7,11.9,27.7,26.6v4.3h-6.2v-4.3c0-11.2-9.7-20.4-21.6-20.4s-21.6,9.2-21.6,20.4v4.3h-6.2 V138.4z M287.7,142.7h-30.8v-4.3c0-7.8,6.9-14.2,15.4-14.2s15.4,6.4,15.4,14.2V142.7z M219.9,148.9h104.7v49.3H219.9V148.9z  M146,488.1V167.4h67.7v33.9c0,1.7,1.4,3.1,3.1,3.1h110.9c1.7,0,3.1-1.4,3.1-3.1v-33.9h67.7v154.4c-30.8,1.6-55.4,27.2-55.4,58.4 s24.6,56.8,55.4,58.4v49.5H146z M401.6,432.6c-28.9,0-52.3-23.5-52.3-52.4s23.5-52.4,52.3-52.4c28.9,0,52.3,23.5,52.3,52.4 S430.5,432.6,401.6,432.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.6,361L433,350.5c-1.2-1.2-3.2-1.2-4.4,0l-34.8,34.8L377.6,369c-1.2-1.2-3.2-1.2-4.4,0l-10.5,10.5 c-1.2,1.2-1.2,3.2,0,4.4l29,29c0.6,0.6,1.4,0.9,2.2,0.9c0.8,0,1.6-0.3,2.2-0.9l47.5-47.5C444.8,364.2,444.8,362.3,443.6,361  M393.9,406.4l-24.6-24.7l6.2-6.2l16.3,16.3c1.2,1.2,3.2,1.2,4.4,0l34.8-34.8l6.2,6.2L393.9,406.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.7b79c509fbb26ef48c0c391c1bc31e55.svg";
export { ForwardRef as ReactComponent };